import dayjs from "dayjs";
import { dateFormat, timeFormat } from "../../util/DateUtil";

export const DIAS_SEMANA = [
  { value: 1, label: "Segunda", curto: "Seg" },
  { value: 2, label: "Terça", curto: "Ter" },
  { value: 3, label: "Quarta", curto: "Qua" },
  { value: 4, label: "Quinta", curto: "Qui" },
  { value: 5, label: "Sexta", curto: "Sex" },
];

// As datas dos períodos vêm em UTC; o dateFormat já trata isso.
const toDia = (data) => {
  if (!data) return null;
  const [dia, mes, ano] = dateFormat(data).split("/").map(Number);
  return dayjs(new Date(ano, mes - 1, dia));
};

export const porDataInicio = (a, b) => (toDia(a.dataInicio)?.valueOf() ?? 0) - (toDia(b.dataInicio)?.valueOf() ?? 0);

/** O período está vigente hoje (início <= hoje <= fim, ou sem fim). */
export const isVigente = (periodo) => {
  const hoje = dayjs().startOf("day");
  const inicio = toDia(periodo.dataInicio);
  const fim = toDia(periodo.dataFim);
  return Boolean(inicio) && !inicio.isAfter(hoje) && (!fim || !fim.isBefore(hoje));
};

// Ordena por dia e, dentro do dia, pelo horário de início ("HH:mm" ordena como texto);
// a ordem da aula só desempata.
export const porDiaEHorario = (a, b) =>
  (a.diaSemana ?? 0) - (b.diaSemana ?? 0) ||
  timeFormat(a.cronogramaAula?.horarioInicio).localeCompare(timeFormat(b.cronogramaAula?.horarioInicio)) ||
  (a.cronogramaAula?.ordemAula ?? 0) - (b.cronogramaAula?.ordemAula ?? 0);

export const mensagemDe = (data, padrao) => (Array.isArray(data?.message) ? data.message.join("\n") : data?.message) || padrao;
